import React from 'react'
import './WelcomePage.css';
import logo from '../images/mac-background.jpg'
import getstarted from '../images/get-started.png'
import {Link} from 'react-router-dom'

function WelcomePage() {
  return (
    <div className='welcome'>
      <img 
      className='bg'
      src={logo}
      alt=''
      />
      <div className='content'>
        <h1>Welcome!</h1>
        
      </div>
      <div className='getstarted'>
      <Link
      to="/home"
      >
      <img 
        src={getstarted}
        alt=''
        className='next'
        />
      </Link>
      
        <p className='alt'>Get Started</p>
      </div>
    </div>
  )
}

export default WelcomePage
